import { render, staticRenderFns } from "./ItemStatusSelect.vue?vue&type=template&id=f89975dc&scoped=true&"
import script from "./ItemStatusSelect.vue?vue&type=script&lang=js&"
export * from "./ItemStatusSelect.vue?vue&type=script&lang=js&"
import style0 from "./ItemStatusSelect.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ItemStatusSelect.vue?vue&type=style&index=1&id=f89975dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f89975dc",
  null
  
)

export default component.exports